import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { store, loadStore } from "store";
import axios from "axios";
var AiRenameDeviceModal = /** @class */ (function (_super) {
    tslib_1.__extends(AiRenameDeviceModal, _super);
    function AiRenameDeviceModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.newName = "";
        return _this;
    }
    AiRenameDeviceModal.prototype.beforeOpen = function (e) {
        this.device = e.params.device;
        this.$root.$on("back", this.back);
    };
    AiRenameDeviceModal.prototype.opened = function () {
        var input = this.$refs.newNameInput;
        input.focus();
        input.select();
    };
    AiRenameDeviceModal.prototype.closed = function () {
        this.$root.$off("back", this.back);
    };
    AiRenameDeviceModal.prototype.back = function (e) {
        e.stop();
        this.$modal.hide("rename-device");
    };
    AiRenameDeviceModal.prototype.doRename = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 4]);
                        return [4 /*yield*/, axios.post("devices/renameUserDevice", {
                                serialNumber: this.device.serial,
                                token: store.sessionToken,
                                name: this.newName
                            })];
                    case 1:
                        _a.sent();
                        this.device.name = this.newName;
                        return [3 /*break*/, 4];
                    case 2:
                        err_1 = _a.sent();
                        return [4 /*yield*/, this.$showDialog({ text: this.$t("deviceView.errorRenamingUserDevice") })];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                    case 4: return [4 /*yield*/, loadStore()];
                    case 5:
                        _a.sent();
                        this.$modal.hide("rename-device");
                        return [2 /*return*/];
                }
            });
        });
    };
    AiRenameDeviceModal = tslib_1.__decorate([
        Component
    ], AiRenameDeviceModal);
    return AiRenameDeviceModal;
}(Vue));
export default AiRenameDeviceModal;
